import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const OrganisationSchema = () => {
  return (
    <Head>
      <script
        id="OrganizationSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: siteInfo?.siteName,
            url: process.env.NEXT_PUBLIC_WEBSITE_URL,
            Image: [`${siteInfo?.siteLogo}`],
            logo: {
              "@type": "ImageObject",
              url: `${siteInfo?.siteLogo}`,
              width: 160,
              height: 60,
            },
              address: {
                "@type": "PostalAddress",
                streetAddress: "FC8, Film City, Sector 16A",
                addressLocality: "Noida",
                addressRegion: "Uttar Pradesh",
                postalCode: "201301",
                addressCountry: "IN"
              },
              telephone: "+91-120-4807100",
            sameAs: [
              siteInfo.socialLinks.facebook,
              siteInfo.socialLinks.youtube,
              siteInfo.socialLinks.twitter,
              siteInfo.socialLinks.instagram,
            ],
          }),
        }}
      />
    </Head>
  );
};

export default OrganisationSchema;
